import NextLink from 'next/link'
import { IFeedRecord } from '@/interfaces/IFeedRecord'
import styles from './TextSection.module.scss'

function trimText (text: string, limit: number) {
  if (text.length <= limit) return text

  const trimmedText = text.substring(0, limit)
  return trimmedText.substring(0, Math.min(trimmedText.length, trimmedText.lastIndexOf(' '))) + '...'
}

interface TextSectionProps {
  record: IFeedRecord
}

function TextSection ({ record }: TextSectionProps) {
  return (
    <>
      <NextLink
        className={styles.wrapper}
        href={`/${record.slug}`}
      >
        <div className={styles.title}>
          {record.title}
        </div>
        {record.subtitle &&
          <div className={styles.subtitle}>
            {record.subtitle}
          </div>
        }
      </NextLink>
      <NextLink
        href={`/${record.slug}`}
        style={{ width: '100%'}}
      >
        <div className={styles.text}>
          {trimText(record.text || '', 225)}
        </div>
      </NextLink>
    </>
  )
}

export default TextSection
